// 261030 S6 — `409 PLAN_BUSY`: route sửa bước ① làm lại tối đa 4 lần phía BE rồi vẫn bị thao tác khác đổi dữ liệu ⇒ 409, KHÔNG ghi gì. Không phải lỗi hệ thống:
// FE hiện câu nhẹ «Đang có thay đổi khác — thử lại», tải lại status (băm mới), để người bấm lại; lớp API tự thử lại MỘT lần sau ~2 s. THUẦN (không antd).
export const PLAN_BUSY_CODE = 'PLAN_BUSY';
export const PLAN_BUSY_TEXT = 'Đang có thay đổi khác — thử lại.';
export const PLAN_BUSY_RETRY_MS = 2000;

export const isPlanBusy = (err: any): boolean => err?.response?.status === 409 && (err?.response?.data?.code ?? err?.response?.data?.errorCode) === PLAN_BUSY_CODE;

/** Gọi `call`; PLAN_BUSY ⇒ đợi `delayMs` rồi thử lại ĐÚNG MỘT lần (cùng body / requestId — BE idempotent, lần trước không ghi gì). Lỗi khác / lần hai vẫn lỗi ⇒ ném ra như cũ. */
export async function retryOncePlanBusy<T>(call: () => Promise<T>, o: { delayMs?: number; sleep?: (ms: number) => Promise<void> } = {}): Promise<T> {
  try { return await call(); }
  catch (err) {
    if (!isPlanBusy(err)) throw err;
    await (o.sleep ?? ((ms: number) => new Promise<void>((r) => setTimeout(r, ms))))(o.delayMs ?? PLAN_BUSY_RETRY_MS);
    return call();
  }
}
